import type { SyncQueueItem } from './syncTypes';

export type FlushRpcResult = { ok: true } | { ok: false; error: string };

export type FlushRpcAdapter = (item: SyncQueueItem) => Promise<FlushRpcResult>;

export type SupabaseRpcError = { message?: string; details?: string; hint?: string };

export const rpcErrorMessage = (error: SupabaseRpcError | null): string => {
  if (!error) return 'Error desconocido';
  return [error.message, error.details, error.hint].filter(Boolean).join(' | ') || 'Error RPC';
};

export const toFlushOk = (): FlushRpcResult => ({ ok: true });

export const toFlushErr = (error: SupabaseRpcError | null): FlushRpcResult => ({
  ok: false,
  error: rpcErrorMessage(error),
});

/**
 * Interpreta respuestas jsonb `{ ok, code?, stale? }` de command RPCs.
 * - `ok:false` → error (usa `code` si viene)
 * - `stale:true` → error `stale` (LWW descartó el write; no reintentar en cola)
 * - resto → ok
 */
export const interpretJsonbCommandResult = (data: unknown): FlushRpcResult => {
  if (data == null || typeof data !== 'object') return toFlushOk();
  const row = data as { ok?: unknown; code?: unknown; stale?: unknown };
  if (row.stale === true) {
    return { ok: false, error: 'stale' };
  }
  if (row.ok === false) {
    const code = typeof row.code === 'string' && row.code.trim() ? row.code.trim() : 'rpc_rejected';
    return { ok: false, error: code };
  }
  return toFlushOk();
};
